import { schema } from 'normalizr'

const deliveryOrder = new schema.Entity('deliveryOrders', {})

export default deliveryOrder
